export default __webpack_public_path__ + "static/media/panjab-govt.c5e4b8f7.jpg";